<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Salesforce Glyph" class="d-icon d-icon--salesforce-glyph" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><rect width="24" height="24" rx="2" fill="#00A1E0"/><path d="M10.323 6.419a3.637 3.637 0 0 1 2.536-1.011c1.32 0 2.472.683 3.085 1.698a4.543 4.543 0 0 1 1.744-.344C20.07 6.762 22 8.57 22 10.8c0 2.231-1.93 4.04-4.312 4.04-.285 0-.57-.027-.849-.08-.54.896-1.57 1.5-2.751 1.5-.494 0-.962-.106-1.379-.295C12.162 17.161 10.886 18 9.4 18c-1.549 0-2.868-.91-3.375-2.186a3.54 3.54 0 0 1-.686.067C3.495 15.88 2 14.479 2 12.749c0-1.16.672-2.172 1.67-2.713a3.368 3.368 0 0 1-.32-1.433c0-1.99 1.739-3.602 3.884-3.602 1.26 0 2.38.556 3.089 1.418Z" fill="#fff"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconSalesforceGlyph',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
